'use client';
import styled from 'styled-components';

export const AllowNewLine = styled.span`
  white-space: pre-line;
`;
